import { useMutation, useQueryClient } from '@tanstack/react-query';
import request from '@teetsh/app/src/utils/request';
import { USER_ACCOUNT_KEY } from './useUserAccount';
import { USER_KEY } from '@teetsh/app/src/queries/user/useUser';
import { UserLocale } from '@teetsh/app/src/types/user';
import { UserRole } from '@teetsh/app/src/containers/Demarrage/types';

interface Payload {
  email: string;
  familyName: string;
  givenName: string;
  location: string;
  country?: string;
  locale?: UserLocale;
  optin: boolean;
  userRoles?: UserRole[];
}

export default function useUpdateUserAccount() {
  const queryClient = useQueryClient();

  const { mutateAsync } = useMutation({
    mutationFn: (userAccount: Payload) =>
      request('/users/account', {
        method: 'PATCH',
        body: userAccount,
      }),

    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: [USER_ACCOUNT_KEY],
      });
      queryClient.invalidateQueries({
        queryKey: [USER_KEY],
      });
    },
  });
  return mutateAsync;
}
